'use client';

import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
import Footer from '@sbt-web/footer';
import { UserProvider } from '@/client/contexts/UserContext';
import { HeaderWrapper } from '@/components/HeaderWrapper';
import '@sbt-web/footer/dist/index.css';
import '@sbt-web/header/dist/index.css';
import styles from './index.module.scss';
interface BackboneProps {
  children: ReactNode;
}
export const Backbone = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <HeaderWrapper />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== children) {
    t2 = <main className={styles.main}>{children}</main>;
    $[1] = children;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className={styles.footer_wrapper}><Footer type="full" assetsBase={process.env.NEXT_PUBLIC_ASSETS_BASE_URL} /></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== t2) {
    t4 = <UserProvider><>{t1}{t2}{t3}</></UserProvider>;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};